export default __webpack_public_path__ + "7f28ba49597ee7ae95be87c9ef06798a.png";